import { sendToApi } from 'api/client'

export interface ZapierTargetUpdate {
  is_blog_destination?: boolean
  is_email_destination?: boolean
}

export const ZapierTargetsClient = {
  setDestinationFlags: async (workspaceId: number, integrationId: number, flags: ZapierTargetUpdate) => {
    return sendToApi<{ id: number; subscription_name: string; hook_url: string; workspace_id: number }>(
      `/w/${workspaceId}/zapier_targets/${integrationId}`,
      {
        method: 'PUT',
        body: flags,
      },
    )
  },
}
